export default {
  computed: {
    orderDetailsUrl() {
      return function(orderId) {
          return `/my-account/order-history/${orderId}`
      }
    }
  }
}